import { createSlice } from "@reduxjs/toolkit";
import { SUCCESS_STATUS } from "../constants";
import { Service } from "../service";
import { setError, setLoading } from "./appSlice";

const { request } = Service;

export const usageAnalyticsReportSlice = createSlice({
  name: "usageAnalyticsReport",
  initialState: {
    customerFacilities: {},
    treatmentCustomerFacilities: {},
  },
  reducers: {
    setCustomerFacilities: (state, action) => {
      state.customerFacilities = action.payload;
    },
    setTreatmentCustomerFacilities: (state, action) => {
      state.treatmentCustomerFacilities = action.payload;
    },
  },
});

export const { setCustomerFacilities, setTreatmentCustomerFacilities } = usageAnalyticsReportSlice.actions;

const facilityEndpoint = (customerNumber) =>
  customerNumber ? `/getpatientcustomerfacilities?customerNumber=${customerNumber}` : "/listoptions/facility";

export const getFaciltiestCustomerAsyn = (customerNumber) => async (dispatch) => {
  dispatch(setCustomerFacilities([]));
  try {
    dispatch(setLoading(true));
    const data = await request(facilityEndpoint(customerNumber), { method: "GET" });
    if (data?.status === SUCCESS_STATUS) {
      dispatch(setCustomerFacilities(data));
    }
  } catch (error) {
    const errorData = { ...error };
    dispatch(setError(errorData.errorMessage));
    dispatch(setCustomerFacilities(errorData));
  } finally {
    dispatch(setLoading(false));
  }
};

export const getTretmentFaciltiestCustomerAsyn = (customerNumber) => async (dispatch) => {
  dispatch(setTreatmentCustomerFacilities([]));
  try {
    dispatch(setLoading(true));
    const data = await request(facilityEndpoint(customerNumber), { method: "GET" });
    if (data?.status === SUCCESS_STATUS) {
      dispatch(setTreatmentCustomerFacilities(data));
    }
  } catch (error) {
    const errorData = { ...error };
    dispatch(setError(errorData.errorMessage));
    dispatch(setTreatmentCustomerFacilities(errorData));
  } finally {
    dispatch(setLoading(false));
  }
};

export default usageAnalyticsReportSlice.reducer;
